import {h, Fragment} from "preact"
import { useSizeOptions } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { defaultConfig, sizes } from "../config"
import { useState } from "preact/hooks";

export default function Progressbar() {
    const { to, total } = useSizeOptions(sizes, defaultConfig.serpSize);

    const [progress, setProgress] = useState(0);
    
    useEffect(()=>{
        const progress = (to / total) * 100;
        if(progress >=100){
            setProgress(100);
        } else {
            setProgress(progress);
        }
        
    }, [to, total])

    return (
        <div class="progress-bar"><div class="progress-bar__inner" style={{width:`${progress}%`}}></div></div>
    )
}